import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import {
	compareEntities,
	compareEntity,
	isEquals,
} from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { CvTemplateRepositoryPort } from 'application/template/cv/port/cv-template-repository.port';
import {
	CvTemplateState,
	CvTemplateStore,
} from 'document/cv/template/cv-template-store.service';
import { CvTemplate } from 'domain/template/cv/cv-template';

import { CacheObservable } from '../../../../app-decorators';

@Injectable()
export class CvTemplateRepositoryAdapter
	extends QueryEntity<CvTemplateState>
	implements CvTemplateRepositoryPort
{
	constructor(protected store: CvTemplateStore) {
		super(store);
	}

	@CacheObservable()
	public observeCvTemplates(organizationId: string): Observable<CvTemplate[]> {
		return this.selectAll({
			filterBy: (entity) =>
				isEquals(entity.organizationId, organizationId) || !entity.organizationId,
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveCvTemplates(entities: CvTemplate[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
